<template>
  <div class="imgWrapper">
    <v-img
        v-show="$vuetify.breakpoint.smAndUp"
        class="pt-0 d-lg-flex"
        src="../../public/assets/phone.png"
        :width="$vuetify.breakpoint.mdAndUp ? '360px' : $vuetify.breakpoint.width > 820 ? '340px' : $vuetify.breakpoint.width > 720 ? '300px' : '260px'"
        style="position: relative;">
      <v-card class="notificationMockup">
        <v-icon color="amber">mdi-alert-box</v-icon>
        <p class="appHeading" :class="{'ml-4': $vuetify.breakpoint.lgAndUp, 'ml-2': $vuetify.breakpoint.mdAndDown}" style="display: inline;">DoE Staff</p>
        <div :class="{'ml-10': $vuetify.breakpoint.lgAndUp, 'ml-8': $vuetify.breakpoint.mdAndDown}">
          <h1 class="mt-1 messageTitle">{{ title }}</h1>
          <p class="mt-1 mb-0 messageBody">{{ body }}</p>
        </div>
      </v-card>
    </v-img>
  </div>
</template>
<script>
export default {
  name: 'MockPhone',
  props: {
    body: {},
    title: {}
  }
}
</script>
<style lang="scss" scoped>

::v-deep.theme--light .v-textarea .v-input__control .v-input__slot .v-text-field__slot label {
  font-size: 16px;
}

::v-deep #discardButton > span > span {
  padding-left: 0 !important;
}

.notificationMockup {
  width: 91%;
  min-height: 15%;
  position: absolute;
  top: 15%;
  left: 5%;
  padding: 12px;
  font-size: 14px;
  border-radius: 6px;
}

.messageTitle {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.messageBody {
  line-height: 18px;
  height: 36px;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media screen and (max-width: 720px) {
  .appHeading {
    font-size: 12px;
  }
  .messageTitle {
    font-size: 12px;
  }

  .messageBody {
    font-size: 12px;
  }
}
</style>
